import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import * as serviceWorker from 'src/serviceWorker';
import { SettingsProvider } from 'src/contexts/SettingsContext';
import routes from 'src/routes';
import config from './config';

if (config.envi === 'development') {
  window['ga-disable-G-GN4TTJ9S3P'] = true;
}

const router = createBrowserRouter(routes);

ReactDOM.render(
  <SettingsProvider>
    <RouterProvider router={router} />
  </SettingsProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
